function getMidnightTimestamp(unixTimestamp) {
  const date = new Date(unixTimestamp * 1000);
  date.setHours(0, 0, 0, 0);
  return Math.floor(date.getTime() / 1000);
}

/**
 * Method used to compute the min parameter for date pickers used inside networkV2 pop-ups
 * @returns midnight timestamp in seconds taking in consideration the user's timezone
 */
export function computeMinTimestampForDatePicker(): number {
  const now = Math.floor(Date.now() / 1000);
  const timezoneOffset = Application.Main.getUser().profile.timezoneOffset;
  if (!timezoneOffset) {
    return now;
  }

  const timezoneHour = parseInt(timezoneOffset.split(':')[0], 10);
  const timezoneMinute = parseInt(timezoneOffset.split(':')[1], 10);
  const timestampDiff = Math.abs(timezoneHour) * 60 * 60 + timezoneMinute * 60;

  if (timezoneHour < 0) {
    return getMidnightTimestamp(now - timestampDiff);
  }

  return getMidnightTimestamp(now + timestampDiff);
}

/**
 * Method used inside networkV2 pop-ups to get date elements necessary to create certain scheduled tasks
 * The method returns
 * - fullDate - in format MM/DD/YYYY
 * - hour
 * - minute
 *
 * @param timestamp - selected timestamp from which we need to extract date elements
 */
export function getDateElementsFromTimestampString(timestamp: number): {
  fullDate: string;
  hour: number;
  minute: number;
} {
  const dateObj = new Date(timestamp);

  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const year = String(dateObj.getFullYear()).slice(-2);
  const hour = dateObj.getHours();
  const minute = dateObj.getMinutes();

  return {
    fullDate: `${month}/${day}/${year}`,
    hour: hour,
    minute: minute,
  };
}
